﻿$(document).ready(function () {

    var url = window.location.href;
    //console.log(url);

    var code_verifier = sessionStorage.getItem("code_verifier_set");
    
    generateCodeVerifier()
    submit()
    //alert(code_verifier)

    sessionStorage.removeItem("code_verifier");
    sessionStorage.setItem("code_verifier", $("#code_verifier").val());

    var clientId = sessionStorage.getItem("CareIoClientId");
    var SignupPolicyId = sessionStorage.getItem("SignupPolicyId");
    var SignInPolicyId = sessionStorage.getItem("SignInPolicyId");
    var redirectUri = sessionStorage.getItem("RedirectUri");
    var AuthenticationApi = sessionStorage.getItem("AuthenticationApi");
    var CareIoDalApi = sessionStorage.getItem("CareIoDalApi");
    var CareIoDalMasterApi = sessionStorage.getItem("CareIoDalMasterApi");

    //var clientId = "aff5fc48-cb15-44fa-b321-0e49a1c3514e";
    //var redirectUri = "https://localhost:44376";
    //var redirectUri = "https://webapp-careio-useast2-dev.azurewebsites.net/";
    var codeChallenge = $("#code_challenge").val();
    var codeChallengeMethod = "S256";
    //var AuthenticationApi = "https://localhost:7008/";
    //var AuthenticationApi = "https://api-authentication-eastus2-dev.azurewebsites.net/";
    //var CareIoDalApi = "https://apiapp-dal-useast2-dev.azurewebsites.net/api/";

    var urlapp = window.location.href;

    if (url.split("linkId=")[1] != undefined) {
        //var hash = CryptoJS.SHA256(url.split("code=")[1]).toString();
        //console.log(hash);
        //alert(url.split("linkId=")[1])
        sessionStorage.setItem("linkId", url.split("linkId=")[1]);
        $.ajax({
            url: AuthenticationApi + "user/invite/validate?linkId=" + url.split("linkId=")[1],
            method: "GET",
            async: false,
            headers: {
                'Authorization': 'Bearer ' + sessionStorage.getItem("AccessToken")
            },
            contentType: "application/json",
            dataType: 'json',
            success: function (data) {
                //console.log(data.Message);
                
                if (data.Message != "User Not Present") {
                    //This is for login page redirection if user already exist in our system
                    sessionStorage.setItem("AccessType", "")
                    window.location.href = "https://careiob2c.b2clogin.com/account.care.io/oauth2/v2.0/authorize?p=" + SignInPolicyId +"&client_id=" + clientId + "&nonce=defaultNonce&redirect_uri=" + redirectUri + "&scope=openid&response_type=code&prompt=login&code_challenge_method=" + codeChallengeMethod + "&code_challenge=" + codeChallenge + "&linkId=" + urlapp.split("linkId=")[1]
                } else {
                    //This is for signup page redirection if user not exist in our system
                    sessionStorage.setItem("AccessType", "signup")
                    window.location.href = "https://careiob2c.b2clogin.com/account.care.io/oauth2/v2.0/authorize?p=" + SignupPolicyId +"&client_id=" + clientId + "&nonce=defaultNonce&redirect_uri=" + redirectUri + "&scope=openid&response_type=code&prompt=login&code_challenge_method=S256&code_challenge=" + codeChallenge + "&linkId=" + urlapp.split("linkId=")[1]
                }
            },
            error: function (error) {
            }
        });
    } else if (url.split("code=")[1]) {
        // This will work for normal login page
        var urlCode = window.location.href;
        var accessType = sessionStorage.getItem("AccessType");
        $.ajax({
            url: AuthenticationApi + "Login",
            method: "POST",
            data: JSON.stringify({ Code: urlCode.split("code=")[1], CodeVerifier: code_verifier, AccessType: accessType }),
            async: false,
            contentType: "application/json",
            dataType: 'json',
            statusCode: {
                200: function (response) {
                    
                    //console.log(response.refresh_token)
                    //sessionStorage.removeItem('AccessToken');
                    sessionStorage.setItem("AccessToken", response.access_token);
                    sessionStorage.setItem("AccessTokenRefresh", response.refresh_token);
                    sessionStorage.setItem("AccessTokenValid", response.expires_in);

                    var accessTokenValidTill = new Date(); // Save the current date and time
                 
                    accessTokenValidTill.setMinutes(accessTokenValidTill.getMinutes() + 50);
                   
                    sessionStorage.setItem("AccessTokenValidTill", accessTokenValidTill.toUTCString());

                    //This api call for when have linkId in URL
                    if (sessionStorage.getItem("linkId") != null) {
                        if (sessionStorage.getItem("AccessType") != "signup") {
                            $.ajax({
                                url: AuthenticationApi + "user/invite/accept?linkId=" + sessionStorage.getItem("linkId"),
                                method: "GET",
                                headers: {
                                    'Authorization': 'Bearer ' + sessionStorage.getItem("AccessToken")
                                },
                                async: false,
                                contentType: "application/json",
                                dataType: 'json',
                                statusCode: {
                                    200: function (response) {
                                        sessionStorage.removeItem("linkId")
                                        $("#Message").html("<div class='alert alert-success'><i class='fa fa-check-circle'></i> User accepted successfully. <button type='button' class='close' data-dismiss='alert'>&times;</button></div>").delay(3000).fadeOut();
                                    }
                                },
                                success: function () {
                                    sessionStorage.removeItem("linkId")
                                    $("#Message").html("<div class='alert alert-success'><i class='fa fa-check-circle'></i> User accepted successfully. <button type='button' class='close' data-dismiss='alert'>&times;</button></div>").delay(3000).fadeOut();
                                },
                                error: function (error) {
                                    sessionStorage.removeItem("linkId")
                                }
                            });
                        }
                    }
                    sessionStorage.removeItem("AccessType")

                    $.ajax({
                        url: CareIoDalApi + "Organization/list",
                        method: "GET",
                        async: false,
                        contentType: "application/json",
                        headers: {
                            'Authorization': 'Bearer ' + response.access_token
                        },
                        dataType: 'json',
                        success: function (data) {
                            /*//console.log(data);*/
                            sessionStorage.setItem("Organizations", JSON.stringify(data));
                            var decodedToken = parseJwt(sessionStorage.getItem("AccessToken"));
                          //  sessionStorage.setItem("CareCode", decodedToken.streetAddress)
                            sessionStorage.setItem("OperatingId", "1234")
                            //parseJwt(sessionStorage.getItem("AccessToken"))
                            //sessionStorage.setItem("OrganizationJobTitle", jobTitle);
                            //sessionStorage.setItem("OrganizationJobTitle", jobTitle);
                            //sessionStorage.setItem("CareCode", GetCareCode);                          
                            $.ajax({
                                url: CareIoDalMasterApi + "carecode/" + decodedToken.streetAddress ,
                                method: "GET",
                                async: false,
                                contentType: "application/json",
                                headers: {
                                    'Authorization': 'Bearer ' + response.access_token
                                },
                                dataType: 'json',
                                success: function (data) {
                                    sessionStorage.setItem("CareCode", data.displayValue)
                                }
                            });
                            //This organizationId use for only first load of page
                            var orgList = JSON.parse(sessionStorage.getItem("Organizations"));

                            if (orgList.length == 1) {
                                if (orgList[0].organizationName == "My Health Records") {
                                    sessionStorage.setItem("myHealthData", true);
                                } else {
                                    sessionStorage.setItem("myHealthData", false);
                                }
                            }

                            /*//console.log(orgList);*/
                           
                            if (localStorage.getItem("SelectedOrgId") == null || localStorage.getItem("SelectedOrgId") == "") {
                                if (orgList.length == undefined) {
                                   
                                    sessionStorage.setItem("orgId", orgList.organizationId);
                                    sessionStorage.setItem("orgName", orgList.organizationName);
                                } else {
                                    var isDefaultPresent = false;
                                    for (var m = 0; m < orgList.length; m++) {
                                        if (orgList[m].isDefault == true) {
                                            isDefaultPresent = true;
                                            sessionStorage.setItem("orgId", orgList[m].organizationId);
                                            sessionStorage.setItem("orgName", orgList[m].organizationName);
                                            sessionStorage.setItem("roleId", orgList[m].roleId);

                                            localStorage.setItem("SelectedOrgName", orgList[m].organizationName)
                                            localStorage.setItem("SelectedOrgId", orgList[m].organizationId)
                                        }
                                    }
                                    if (isDefaultPresent == false) {
                                        
                                        sessionStorage.setItem("orgId", orgList[0].organizationId);
                                        sessionStorage.setItem("orgName", orgList[0].organizationName);
                                        sessionStorage.setItem("roleId", orgList[0].roleId);
                                    }
                                }
                            } else {
                                
                                var orgId = localStorage.getItem("SelectedOrgId");
                                var orgName = localStorage.getItem("SelectedOrgName");
                                var roleId = localStorage.getItem("SelectedRoleId");
                                sessionStorage.setItem("orgId", orgId);
                                sessionStorage.setItem("orgName", orgName);
                                sessionStorage.setItem("roleId", roleId);

                            }

                            if (sessionStorage.getItem("GatewayPageRedirect") == null) {
                                //If role is document management then redirect to document management page
                                if (sessionStorage.getItem("roleId") == "bdffafdd-a63d-46cd-84dd-22774ab7d4ea" || sessionStorage.getItem("roleId") == "a44f581a-79c5-47d4-8826-82a53176cd9b" || sessionStorage.getItem("roleId") == "bdccddff-e865-4f9c-a7c5-a64c05090e50" || sessionStorage.getItem("roleId") == "26a47614-c746-4adb-9537-66f322f79c68" || sessionStorage.getItem("roleId") == "fe7f7fe0-4113-4cd4-95ed-d5b80427f50d" || sessionStorage.getItem("roleId") == "9b52a7c7-72f1-444d-bc9a-3f2b2e46191a" || sessionStorage.getItem("roleId") == "48334b27-f185-4aae-b882-515d649086f3" || sessionStorage.getItem("roleId") == "04bf11b4-2f72-41c7-b536-a51a870d1ada" || sessionStorage.getItem("roleId") == "5e9f2163-e011-406e-87ee-0ca414378f5e" || sessionStorage.getItem("roleId") == "fc28551c-c5c1-4766-a7a5-9788c633b1b7" || sessionStorage.getItem("roleId") == "f82e4b86-bc2f-4398-a593-f06135e29363" || sessionStorage.getItem("roleId") == "991a11b0-9900-4051-a74e-7c3efb2776ac" || sessionStorage.getItem("roleId") == "06fb3f35-e750-4cc8-aec5-6a4fbc17d3b4" || sessionStorage.getItem("roleId") == "261ea288-67bf-420f-9fec-abd3af6d399f" || sessionStorage.getItem("roleId") == "a2951029-4174-496b-bf4c-abb9ef9e604d" || sessionStorage.getItem("roleId") == "8c22be2c-0586-464a-b913-3cf385f6b3b9" || sessionStorage.getItem("roleId") == "3a244f96-7ba5-4aa3-892d-5c41c5c24c78" || sessionStorage.getItem("roleId") == "1dd192d4-e131-4325-8f7e-f188e5030fb2" || sessionStorage.getItem("roleId") == "4f88e221-46ee-4e79-b4cf-afe74059d4d0") {
                                    window.location.href = "../documentmanagement";
                                } else if (sessionStorage.getItem("roleId") == "cccc4255-466b-41fa-b932-75e6bdf24c32" || sessionStorage.getItem("roleId") == "77b785f4-c9b0-4f7f-9d72-9d5a492b167c" || sessionStorage.getItem("roleId") == "8309e89f-9e1d-414f-ac73-b064016cf171" || sessionStorage.getItem("roleId") == "70f2f3af-c30a-448f-997e-4933861d056a" || sessionStorage.getItem("roleId") == "bbb716e8-ec52-46e4-a70a-f47061e2d466" || sessionStorage.getItem("roleId") == "3302f751-b359-4600-8a96-b54d4f55ede3" || sessionStorage.getItem("roleId") == "7ce81275-9033-4167-9f37-29ea0f08bcd4" || sessionStorage.getItem("roleId") == "b5ee94aa-eb1a-45c3-8deb-2cce7b74beb7") {
                                    window.location.href = "../cache";
                                } else if (sessionStorage.getItem("roleId") == "2cc75fd2-7f70-42d6-96b2-9c0b5bf99897") {
                                    window.location.href = "../diagnosticreport";
                                } else {
                                    window.location.href = "../imagingstudy";
                                }
                                
                            } else {
                                window.location.href = "../Gateway/GetKey?" + sessionStorage.getItem("GatewayPageRedirect");
                            }

                        },
                        error: function (error) {

                        }
                    });
                },
                400: function (response) {
                    var redirectToLogin = response.responseJSON.error_description.split(":")[0]
                    if (redirectToLogin == "AADB2C90088") {
                        //window.location.href = "https://careiob2c.b2clogin.com/account.care.io/oauth2/v2.0/authorize?p=" + SignInPolicyId +"&client_id=" + clientId + "&nonce=defaultNonce&redirect_uri=" + redirectUri + "&scope=openid&response_type=code&prompt=login&code_challenge_method=" + codeChallengeMethod + "&code_challenge=" + codeChallenge
                        //For Production Only disable above when below is enable
                        window.location.href = "https://careiob2c.b2clogin.com/account.care.io/" + SignInPolicyId + "/oauth2/v2.0/authorize?client_id=" + clientId +"&nonce=defaultNonce&redirect_uri=" + window.location.origin + "&scope=openid&response_type=code&prompt=login&code_challenge_method=" + codeChallengeMethod + "&code_challenge=" + codeChallenge
                    }
                }
            },
            success: function (data) {
                
            },
            error: function (error) {
                //$("body").append("<div id='Message'><div class='alert alert-danger'><i class='fa fa-exclamation-circle'></i> Something went wrong redirecting to login page...</div></div>").delay(3000).fadeOut();
                //setTimeout(function () {
                    window.location.replace(window.location.origin);
                //}, 3000)
            }
        });
    } else {
        if (sessionStorage.getItem("AccessToken") == null) {
            localStorage.removeItem("SelectedOrgId")
            //window.location.href = "https://careiob2c.b2clogin.com/account.care.io/oauth2/v2.0/authorize?p=" + SignInPolicyId +"&client_id=" + clientId + "&nonce=defaultNonce&redirect_uri=" + redirectUri + "&scope=openid&response_type=code&prompt=login&code_challenge_method=" + codeChallengeMethod + "&code_challenge=" + codeChallenge
            //For Production Only disable above when below is enable
            window.location.href = "https://careiob2c.b2clogin.com/account.care.io/" + SignInPolicyId + "/oauth2/v2.0/authorize?client_id=" + clientId +"&nonce=defaultNonce&redirect_uri=" + window.location.origin + "&scope=openid&response_type=code&prompt=login&code_challenge_method=" + codeChallengeMethod + "&code_challenge=" + codeChallenge
        } else {
            window.location.href = "../imagingstudy";
        }
    }

    function generateCodeVerifier() {
        var rand = new Uint8Array(32);
        crypto.getRandomValues(rand);
        var code_verifier = base64URL(new CryptoJS.lib.WordArray.init(rand));
        document.getElementById("code_verifier").value = code_verifier
    }
    function generateCodeChallenge(code_verifier) {
        return code_challenge = base64URL(CryptoJS.SHA256(code_verifier))
    }
    function base64URL(string) {
        return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
    }
    function submit() {
        var code_verifier = document.getElementById("code_verifier").value
        var code_challenge = generateCodeChallenge(code_verifier)
        //console.log(code_verifier)
        //alert(sessionStorage.getItem("code_verifier_set"))
        sessionStorage.setItem("code_verifier_set", code_verifier)
        
        document.getElementById("code_challenge").value = code_challenge
    }

    function parseJwt(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    };
    
})